import { Box, Text, useColorMode } from "theme-ui";
import { DepartmentItem } from "../../../../types/dashboard.types";

const TradesOptionList: React.FC<{
    options: DepartmentItem[]
    selected?: string | null;
    onSelect: (option: DepartmentItem) => void;
}> = ({ options, selected, onSelect }) => {
    const [colorMode] = useColorMode();
    const titleHeader = colorMode === 'light' ? "secondary" : "#dadada";
    function capitalizeFirst(str: string): string {
        if (!str) return str;
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }
    return <Box sx={{ p: 0 }}>
        {options.map((opt: any) => (<Text
            key={opt._id}
            className="text-hover"
            as="p"
            sx={{
                backgroundColor: selected === opt.name ? "rgba(141, 141, 141, 0.2)" : "transparent",
                '&:hover': {
                    backgroundColor: colorMode === 'light' ? '#f5f5f5' : '#333333'
                },
                color: titleHeader,
                cursor: "pointer",
                padding: '10px'
            }}
            onClick={(e: any) => {
                onSelect(opt)
            }}
        >
            {capitalizeFirst(opt.name)}
        </Text>
        ))}
    </Box>
};
export default TradesOptionList